import { Container, Row, Col, Tab } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/projImg1.png";
import projImg2 from "../assets/img/projImg2.png";
import projImg3 from "../assets/img/projImg3.png";
import projImg4 from "../assets/img/projImg4.png";

import projImg5 from "../assets/img/projImg5.png";
import projImg6 from "../assets/img/projImg6.png";

// import projImg5 from "../assets/img/projImg5.jpeg";
// import projImg6 from "../assets/img/projImg6.jpeg";

import projImg9 from "../assets/img/projImg9.jpeg";
import projImg7 from "../assets/img/projImg7.png";
import projImg8 from "../assets/img/projImg8.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "Web Development",
      description: "Website for tourism",
      imgUrl: projImg1,
    },
    {
      title: "Web Development",
      description: "Hotel website using HTML and CSS",
      imgUrl: projImg2,
    },
    {
      title: "Web App Development",
      description: "Image Searching Web App Using React JS",
      imgUrl: projImg3,
    },
    {
      title: "Web App Development",
      description: "Youtube Clone Using React JS",
      imgUrl: projImg4,
    },
    {
      title: "Online News Site",
      description: "Online News Site Using HTML and CSS",
      imgUrl: projImg7,
    },
    {
      title: "Technology Website",
      description: "Website For IT companies using HTML and CSS",
      imgUrl: projImg8,
    },

    {
      title: "Shelter-Connect App",
      description:
        "Used to connect with the nearest community like Legal Aids, Orphange and many more",

      imgUrl: projImg5,
    },

    {
      title: "Planet Statistics App",
      description:
        "Fetching Data from Nasa Api and Displaying in Application using React Native",

      imgUrl: projImg9,
    },

    {
      title: "Votex Gym App",
      description:
        "Used for gym management like attendance, attendance report and payment using React Nativ and Firebase",

      imgUrl: projImg6,
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  {/* <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book.
                  </p> */}
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    {/* <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav> */}
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="section">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Cumque quam, quod neque provident velit, rem
                          explicabo excepturi id illo molestiae blanditiis,
                          eligendi dicta officiis asperiores delectus quasi
                          inventore debitis quo.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Cumque quam, quod neque provident velit, rem
                          explicabo excepturi id illo molestiae blanditiis,
                          eligendi dicta officiis asperiores delectus quasi
                          inventore debitis quo.
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" alt="bg" src={colorSharp2}></img>
    </section>
  );
};
